<template>
<!-- <div></div> -->
    <div class="card card-dashboard-fourteen" style="height:210px" v-loading='loading'>
        <label class="az-content-label">Insurance</label>
        <div class="card-body">
            <div class="row mg-t-15 mg-b-20">
            <div class="col">
                <h4>{{no_insurance}}</h4><label class="lb">{{no_insurance>1||no_insurance===0?"Members":"Member"}}</label>
                <span>{{no_insurance>1||no_insurance===0?"have "+text:"has "+text}}</span>
               
            </div>
            </div>
        </div>
         <div class="card-footer">
            <router-link :to='{path:"/adviserdashboard/insurance",query:{page:"Insurance"}}' style="font-size:12px;font-weight:600"><i class="fa fa-angle-right"></i>Insurance</router-link>
        </div>
    </div>
</template>
<script>
export default {
    name:"insurance",
    data(){
        return{
            no_insurance:'',
            text:'',
            loading:true
        }
    },
    created(){
        this.getInsuranceData();
    },
    methods:{
        getInsuranceData: function(){
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            let brand = localStorage.getItem('brand_code')
            this.$api.adviserdashboard_api.insuranceInfo(brand).then(response =>{
                //get the investments data from response
                this.no_insurance = response.data["no_insurance"]
                this.text="no insurance cover"
                this.loading=false
            })
        }
    }
}
</script>
<style scoped>
.lb{
    font-weight: 700;
    font-size: 12px;
    text-transform: uppercase;
    margin-bottom: 0;
    display: block;
    letter-spacing: .5px;
}
</style>